package com.ijoin.ui.util

import com.ijoin.deeplink.DeepLinkParser
import com.ijoin.platform.encodeUrlComponent

private const val GOOGLE_AUTH_START_PATH = "/api/auth/google/start"
private val MOBILE_SUCCESS_REDIRECT = "${DeepLinkParser.SCHEME}://oauth"

fun buildGoogleAuthStartUrl(baseUrl: String, isMobile: Boolean): String {
    val normalizedBaseUrl = baseUrl.trimEnd('/')
    if (!isMobile) {
        return "$normalizedBaseUrl$GOOGLE_AUTH_START_PATH"
    }
    val redirect = encodeUrlComponent(MOBILE_SUCCESS_REDIRECT)
    return "$normalizedBaseUrl$GOOGLE_AUTH_START_PATH?success_redirect=$redirect"
}
